export const TRACK_EVENT = 'userTracking/TRACK_EVENT';
